//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Assemblies.js";
import "../no/NXObject.js";
let d=[[[0,"RootComponent",0,"Assemblies.ExplodedComponent",0]],[[["destinationExplosion"],"Copy",{},1,0],[["view"],"Show",{},1,0],[["view"],"Hide",{},1,0],[[],"Delete",{},0,0],[["explosions"],"DeleteExplosions",{R_:{nDeletedExplosions:''}},1,0],[["occPart","explosionName"],"Rename",{},2,0],[["selectedComponents","autoExplodeDistance"],"AutoExplodeComponents",{R_:{noOfCompExploded:''}},2,1],[["autoExplodeDistance"],"AutoExplodeAssembly",{R_:{noOfCompExploded:''}},1,1],[["selectedComponents"],"UnexplodeComponents",{},1,0],[[],"UnexplodeAllComponents",{},0,0],[["selectedComponents"],"MoveComponentsToOriginalPosition",{},1,0],[[],"GetPositioner",{R_:{positioner:"Positioning.ComponentPositioner"}},0,0],[["useAdditionalDirections","selectedComponents"],"AutoExplodeSelectedComponents",{R_:{numberOfComponentsExploded:''}},2,0],[["useAdditionalDirections"],"AutoExplodeAllComponents",{R_:{numberOfComponentsExploded:''}},1,0]],[]];
SPLM.Assemblies.Explosion = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Assemblies.Explosion";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Assemblies.Explosion.BlockingOptions = class{
    constructor(searchAdditionalDirections,checkSmallInterferences){
        this.searchAdditionalDirections=searchAdditionalDirections;this.checkSmallInterferences=checkSmallInterferences;}
    get Searchadditionaldirections(){return this.searchAdditionalDirections}
    set Searchadditionaldirections(val){this.searchAdditionalDirections = val}
    get Checksmallinterferences(){return this.checkSmallInterferences}
    set Checksmallinterferences(val){this.checkSmallInterferences = val}
};

SPLM.Assemblies.Explosion.ExplosionOptions = class{
    constructor(forceInterferingComponentsApart,preferConstraintsForDirection,ignoreConstraints){
        this.forceInterferingComponentsApart=forceInterferingComponentsApart;this.preferConstraintsForDirection=preferConstraintsForDirection;this.ignoreConstraints=ignoreConstraints;}
    get Forceinterferingcomponentsapart(){return this.forceInterferingComponentsApart}
    set Forceinterferingcomponentsapart(val){this.forceInterferingComponentsApart = val}
    get Preferconstraintsfordirection(){return this.preferConstraintsForDirection}
    set Preferconstraintsfordirection(val){this.preferConstraintsForDirection = val}
    get Ignoreconstraints(){return this.ignoreConstraints}
    set Ignoreconstraints(val){this.ignoreConstraints = val}
};

export default SPLM;